/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Challenge_Landing_TitleInputs */

const en_starter_challenge_landing_title = /** @type {(inputs: Starter_Challenge_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empower Your Focus, Unlock Reward!`)
};

const ar_starter_challenge_landing_title = /** @type {(inputs: Starter_Challenge_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عزّز تركيزك وافتح المكافآت!`)
};

const de_starter_challenge_landing_title = /** @type {(inputs: Starter_Challenge_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konzentrieren Sie sich, schalten Sie Belohnungen frei!`)
};

const es_starter_challenge_landing_title = /** @type {(inputs: Starter_Challenge_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Potencia tu concentración y desbloquea recompensas!`)
};

const fr_starter_challenge_landing_title = /** @type {(inputs: Starter_Challenge_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cultivez Votre Concentration, Récoltez Vos Récompenses !`)
};

const it_starter_challenge_landing_title = /** @type {(inputs: Starter_Challenge_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rafforza la tua concentrazione, sblocca la ricompensa!`)
};

const ja_starter_challenge_landing_title = /** @type {(inputs: Starter_Challenge_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中力を高めて、報酬を獲得しよう！`)
};

const ko_starter_challenge_landing_title = /** @type {(inputs: Starter_Challenge_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중력을 향상시키고 보상을 받으세요!`)
};

const pt_br_starter_challenge_landing_title = /** @type {(inputs: Starter_Challenge_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortaleça seu foco, desbloqueie recompensas!`)
};

const ru_starter_challenge_landing_title = /** @type {(inputs: Starter_Challenge_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усильте свою концентрацию, разблокируйте награды!`)
};

const th_starter_challenge_landing_title = /** @type {(inputs: Starter_Challenge_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เสริมพลังการโฟกัสของคุณ ปลดล็อกรางวัล!`)
};

const tr_starter_challenge_landing_title = /** @type {(inputs: Starter_Challenge_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanmanızı Güçlendir, Ödülün Kilidini Aç!`)
};

const zh_cn_starter_challenge_landing_title = /** @type {(inputs: Starter_Challenge_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提升你的专注并解锁奖励`)
};

const zh_tw_starter_challenge_landing_title = /** @type {(inputs: Starter_Challenge_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提升你的專注並解鎖獎勵`)
};

/**
* | output |
* | --- |
* | "Empower Your Focus, Unlock Reward!" |
*
* @param {Starter_Challenge_Landing_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_landing_title = /** @type {((inputs?: Starter_Challenge_Landing_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Landing_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_landing_title(inputs)
	if (locale === "ar") return ar_starter_challenge_landing_title(inputs)
	if (locale === "de") return de_starter_challenge_landing_title(inputs)
	if (locale === "es") return es_starter_challenge_landing_title(inputs)
	if (locale === "fr") return fr_starter_challenge_landing_title(inputs)
	if (locale === "it") return it_starter_challenge_landing_title(inputs)
	if (locale === "ja") return ja_starter_challenge_landing_title(inputs)
	if (locale === "ko") return ko_starter_challenge_landing_title(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_landing_title(inputs)
	if (locale === "ru") return ru_starter_challenge_landing_title(inputs)
	if (locale === "th") return th_starter_challenge_landing_title(inputs)
	if (locale === "tr") return tr_starter_challenge_landing_title(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_landing_title(inputs)
	return zh_tw_starter_challenge_landing_title(inputs)
});